/* External */
import { memo } from 'react';
import { Route, Switch } from 'react-router-dom';

/* Components */
import Vod from './Vod';
import Live from './Live';

/* Utils */
import { getPath, Routes } from '../../../utils/router';

function Player() {
  return (
    <Switch>
      <Route path={getPath(Routes.Private.Player.Vod)}>
        <Vod />
      </Route>
      <Route path={getPath(Routes.Private.Player.Live)}>
        <Live />
      </Route>
    </Switch>
  );
}

export default memo(Player);
